import styled from 'styled-components'

export const RadioLabel = styled.label<{ $disabled: boolean }>(({ theme, $disabled }) => ({
  alignItems: 'center',
  cursor: $disabled ? 'not-allowed' : 'pointer',
  display: 'inline-flex',
  gap: theme.space['8'],
  position: 'relative',
}))

export const RadioInput = styled.input({
  height: 0,
  opacity: 0,
  pointerEvents: 'none',
  position: 'absolute',
  width: 0,
})

export const RadioBox = styled.div<{
  $checked: boolean
  $disabled: boolean
}>(({ theme, $checked, $disabled }) => ({
  '&:hover': $disabled
    ? ''
    : {
        borderColor: $checked ? theme.colors.black700 : theme.colors.black500,
      },
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['2']} solid ${
    $checked ? theme.colors.black800 : theme.colors.gray500
  }`,
  borderRadius: theme.border.radius['circle'],
  display: 'flex',
  height: '1.6rem',
  justifyContent: 'center',
  opacity: $disabled ? 0.5 : 1,
  position: 'relative',
  transition: `background-color ${theme.transition.duration.sm}, border-color ${theme.transition.duration.sm}`,
  width: '1.6rem',
}))

export const RadioIndicator = styled.div<{
  $disabled: boolean
}>(({ theme }) => ({
  backgroundColor: theme.colors.black800,
  borderRadius: theme.border.radius['circle'],
  height: '0.8rem',
  width: '0.8rem',
}))

export const RadioLabelText = styled.span<{ $disabled: boolean }>(({ theme, $disabled }) => ({
  color: $disabled ? theme.colors.black200 : theme.colors.black800,
  fontSize: '1.4rem',
  lineHeight: '2rem',
  userSelect: 'none',
}))
